var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14H14.71L14.43 13.73C15.0549 13.004 15.5117 12.1488 15.7675 11.2256C16.0234 10.3025 16.072 9.33416 15.91 8.39001C15.44 5.61001 13.12 3.39001 10.32 3.05001C9.33559 2.92547 8.33576 3.02778 7.397 3.34909C6.45824 3.67041 5.60542 4.20222 4.90381 4.90384C4.20219 5.60545 3.67038 6.45827 3.34906 7.39703C3.02775 8.33579 2.92544 9.33562 3.04997 10.32C3.38997 13.12 5.60998 15.44 8.38998 15.91C9.33413 16.0721 10.3024 16.0234 11.2256 15.7676C12.1487 15.5117 13.0039 15.055 13.73 14.43L14 14.71V15.5L18.25 19.75C18.66 20.16 19.33 20.16 19.74 19.75C20.15 19.34 20.15 18.67 19.74 18.26L15.5 14ZM9.49997 14C7.00997 14 4.99997 11.99 4.99997 9.50001C4.99997 7.01 7.00997 5.00001 9.49997 5.00001C11.99 5.00001 14 7.01 14 9.50001C14 11.99 11.99 14 9.49997 14Z",
    fill: "#667080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7e95726e8d01e4fc740c5762350c6738.svg";
export { ForwardRef as ReactComponent };